import { createFileRoute } from '@tanstack/react-router';

import { DealIntelligencePage } from '@/features/deal-intelligence/components/DealIntelligencePage';
import { PlatformRestriction } from '@/shared/navigation/components/PlatformRestriction';

export const Route = createFileRoute(
  '/_dashboard/deal-intelligence_/project/$projectId_/gap/$gapId'
)({
  component: ProjectGapDetailRoute,
});

function ProjectGapDetailRoute() {
  const { projectId, gapId } = Route.useParams();
  return (
    <PlatformRestriction notAllowedPlatforms={['mobile']}>
      <DealIntelligencePage projectExternalId={projectId} gapId={gapId} />
    </PlatformRestriction>
  );
}
